import { saveLogin } from "@website/hooks/auth-manager";
import { B2BInquiry, B2BOtp } from "@website/widget/login/components";
import {
  LoginPropertiesType,
  LoginStepType
} from "@website/widget/login/login.types";
import { useB2BLogin } from "@website/widget/login/use-b2b-login";
import { FC, memo, useCallback } from "react";

const LoginB2B: FC<LoginPropertiesType> = () => {
  const { step, setStep, userData, setUserData } = useB2BLogin();

  const setStepHandler = useCallback(
    (step: LoginStepType) => {
      setStep(step);
    },
    [setStep]
  );

  const onEndAuth = useCallback(
    (accessToken?: string, refreshToken?: string) => {
      if (accessToken) {
        saveLogin({ accessToken, refreshToken });
        window.location.href = "/";
      }
    },
    []
  );

  return (
    <div className="w-full">
      {step === "phone-number" && (
        <B2BInquiry
          setStep={setStepHandler}
          setUserData={setUserData}
          userData={userData}
        />
      )}
      {step === "otp" && (
        <B2BOtp
          onEndAuth={onEndAuth}
          setStep={setStepHandler}
          setUserData={setUserData}
          userData={userData}
        />
      )}
    </div>
  );
};

const LoginMemoized = memo(LoginB2B);
export { LoginMemoized as LoginB2B };
